export class FetchEventByIdRequest {
    constructor(private eventId?: number){};
}